import Popout from "../../Common/Popout";

export const HelpPopout = ({ showPopout, setShowPopout }) => {
  return (
    <Popout
      showPopout={showPopout}
      setShowPopout={setShowPopout}
      popOutStyles={{
        background: "#1a1c3eeb",
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div>
        <p className="overview-modal-text">
          The calendar uses periodization and colors to indicate how difficult
          each training and game is compared to baselines
        </p>
        <div className="placeholder-wrapper">
          <span className="icon-placeholder1">G</span>
          <p className="placeholder1-text">Filled in G is a Game</p>
        </div>
        <div className="placeholder-wrapper">
          <span className="icon-placeholder2">G</span>
          <p className="placeholder1-text">Non Filled in G is a Future Game</p>
        </div>
        <div className="placeholder-wrapper">
          <span className="icon-placeholder3">G</span>
          <p className="placeholder1-text">Filled in T is a Training </p>
        </div>
        <div className="placeholder-wrapper">
          <span className="icon-placeholder4">G</span>
          <p className="placeholder1-text">
            Non Filled T is the suggested periodization{" "}
          </p>
        </div>
        <div className="placeholder-wrapper">
          <span className="icon-placeholder5"></span>
          <p className="placeholder1-text">
            Red represents over 55% of team baseline
          </p>
        </div>
        <div className="placeholder-wrapper">
          <span className="icon-placeholder6"></span>
          <p className="placeholder1-text">
            Yellow represents 30%-55% of team baseline
          </p>
        </div>
        <div className="placeholder-wrapper">
          <span className="icon-placeholder7"></span>
          <p className="placeholder1-text">
            Green represents below 30% of team baseline
          </p>
        </div>
        <div className="button-wrapper">
          <button
            className="overview-modal-button"
            onClick={() => {
              setShowPopout(false);
            }}
          >
            Got it
          </button>
        </div>
      </div>
    </Popout>
  );
};
